import cookie from 'js-cookie';
import {
    login,
    logout,
    getPrimaryAccountList,
    switchPrimaryAccount,
    getActionMap
} from 'src/api/dev/user';
import * as T from './types';

const module = {
    state: {
        paasName: cookie.get('paas_name') || '',
        isLogin: !!cookie.get('paas_token'),
        identity: {
            userId: cookie.get('user_id'),
            userAccountId: cookie.get('user_account_id'),
            userRelationRole: cookie.get('user_relation_role'),
            paasToken: cookie.get('paas_token')
        },
        site: {
            loading: false
        },
        primaryAccounts: [],
        authorityPoint: {
            // ShowPrivate,             // 私有化部署
            // CreateProduct,           // 创建产品
            // CreateWebapp,            // 创建应用
            // DeleteProduct,           // 删除产品
            // DeleteWebapp,            // 删除应用
            // ModifyProdApi,           // 生产环境 API
            // EnableProdWebappVer,     // 生产环境版本发布
            // ModifyProdAppUpgrade,    // 生产环境APP升级
        }
    },
    mutations: {
        [T.SET_PAAS_NAME](state, name) {
            state.paasName = name;
        },
        [T.SET_LOGIN_STATUS](state, loginStatus) {
            state.isLogin = loginStatus;
            if (!loginStatus) {
                cookie.remove('paas_token');
                cookie.remove('user_id');
                cookie.remove('user_account_id');
                cookie.remove('user_relation_role');
                // 登出，清空identity
                state.identity.userId = '';
                state.identity.paasToken = '';
                state.identity.userAccountId = '';
                state.identity.userRelationRole = '';
            }
        },
        [T.SET_IDENTITY](state, responseData) {
            state.identity.userId = responseData.user_id;
            state.identity.paasToken = responseData.token;
            state.identity.userAccountId = responseData.user_account_id;
            state.identity.userRelationRole = responseData.user_relation_role;
        },
        [T.GET_PRIMARY_ACCOUNTS](state, result) {
            state.primaryAccounts = result;
        },
        [T.CHANGE_IDENTITY](state, result) {
            state.identity.userId = result.user_id;
            state.identity.userAccountId = result.user_account_id;
            state.identity.userRelationRole = result.user_relation_role;
            state.identity.paasToken = result.token;
            cookie.set('paas_token', result.token, { expires: 7 });
            cookie.set('user_id', result.user_id, { expires: 7 });
            cookie.set('user_account_id', result.user_account_id, {
                expires: 7
            });
            cookie.set('user_relation_role', result.user_relation_role, {
                expires: 7
            });
            cookie.set('tenant_app_upgrade', result.tenant_app_upgrade, {
                expires: 7
            });
        },
        [T.CLS_VUEX_DATA](state) {
            // 切换账户清空vuex的数据
            state.product.list.forEach(product => {
                product.webapplist = [];
            });
            state.product.list = [];
            state.product.credList = [];
            state.product.detail = {};
            state.app.base = {};
            state.component.componentList = [];
            state.group.groupList = [];
            state.user.domainUserList = [];
            state.user.current = {
                account: '',
                id: '',
                email: '',
                remark: '',
                mobile: '',
                faked_pwd: '123456789'
            };
        },
        [T.TOGGLE_LOADING](state, target) {
            if (target === undefined) {
                state.site.loading = !state.site.loading;
            } else {
                state.site.loading = !!target;
            }
        },
        [T.GET_AUTH_DOT](state, target) {
            state.authorityPoint = Object.assign(state.authorityPoint, target);
        }
    },
    actions: {
        [T.APP_LOGIN]({ commit }, { account, password, captcha }) {
            return login(account, password, captcha).then(data => {
                commit(T.SET_LOGIN_STATUS, true);
                commit(T.SET_IDENTITY, data);
                commit(T.CLS_VUEX_DATA, data);
                return data;
            });
        },
        [T.APP_LOGOUT]({ commit }) {
            return logout().then(data => {
                commit(T.SET_LOGIN_STATUS, false);
                commit(T.CLS_VUEX_DATA, data);
                return data;
            });
        },
        [T.GET_PRIMARY_ACCOUNTS]({ commit, state }) {
            return getPrimaryAccountList(state.identity.userAccountId)
                .then(data => {
                    commit(T.GET_PRIMARY_ACCOUNTS, data);
                    return data;
                })
                .catch(error => {
                    const data = [];
                    commit(T.GET_PRIMARY_ACCOUNTS, data);
                    return error.toString().indexOf('无开发者账户') === -1
                        ? error
                        : data;
                });
        },
        [T.CHANGE_IDENTITY]({ commit, state }, targetAccount) {
            if (state.identity.userId === targetAccount) {
                return Promise.reject(new Error('已是当前身份'));
            }
            commit(T.TOGGLE_LOADING, true);
            return switchPrimaryAccount(targetAccount).then(data => {
                commit(T.CHANGE_IDENTITY, { targetAccount, ...data });
            });
        },
        [T.TOGGLE_LOADING]({ commit }, target) {
            commit(T.TOGGLE_LOADING, target);
        },
        [T.CLS_VUEX_DATA]({ commit }) {
            commit(T.CLS_VUEX_DATA);
        },
        async [T.GET_AUTH_DOT]({ commit }) {
            commit(T.GET_AUTH_DOT, await getActionMap());
        }
    },
    getters: {
        paasName: state => state.paasName,
        accountId: state => state.identity.userId,
        isDeveloper: state => /^Developer$/i.test(state.identity.userRelationRole)
    }
};
export default module;
